import { useNavigate } from "react-router-dom";

const css = `
@import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&display=swap');

.home {
  min-height: 100vh;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
}

.home-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  max-width: 340px;
  border-top: 1px solid #e8e8e8;
}

.home-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 0;
  border-bottom: 1px solid #e8e8e8;
  cursor: pointer;
  animation: appear 0.3s ease both;
  background: #fff;
  transition: background 0.12s;
}

.home-item:hover { background: #fafafa; }
.home-item:hover .home-arrow { opacity: 1; transform: translateX(0); }

@keyframes appear {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

.home-name {
  font-family: 'DM Mono', monospace;
  font-size: 0.82rem;
  letter-spacing: 0.04em;
  color: #111;
}

.home-arrow {
  font-family: 'DM Mono', monospace;
  font-size: 0.75rem;
  color: #bbb;
  opacity: 0;
  transform: translateX(-4px);
  transition: opacity 0.15s, transform 0.15s;
}
`;

export default function Home({ items = [] }) {
  const navigate = useNavigate();

  return (
    <>
      <style>{css}</style>
      <div className="home">
        <div className="home-list">
          {items.map((item, i) => (
            <div
              key={item.path}
              className="home-item"
              style={{ animationDelay: `${i * 0.06}s` }}
              onClick={() => navigate(item.path)}
            >
              <span className="home-name">{item.name}</span>
              <span className="home-arrow">→</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}